var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('CrmPageHeader', {
    attrs: {
      "title": "Visão geral CRM",
      "subtitle": "".concat(_vm.periodoLabel, " \xB7 funil, tarefas e agenda comercial")
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('button', {
          staticClass: "btn btn-light-success btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.abrirOportunidadesGanhas
          }
        }, [_vm._v(" Ganhas (" + _vm._s(_vm.oportunidadesGanhas.length) + ") ")]), _c('router-link', {
          staticClass: "btn btn-dark btn-sm",
          attrs: {
            "to": {
              name: 'crmFunil'
            }
          }
        }, [_vm._v(" Abrir funil ")]), _c('router-link', {
          staticClass: "btn btn-light-primary btn-sm",
          attrs: {
            "to": {
              name: 'crmAgenda'
            }
          }
        }, [_vm._v(" Abrir agenda ")]), _c('router-link', {
          staticClass: "btn btn-light btn-sm",
          attrs: {
            "to": {
              name: 'crmRelatorios'
            }
          }
        }, [_vm._v(" Relatórios ")])];
      },
      proxy: true
    }])
  }), _c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data inicial"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.filtros.data_inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "data_inicio", $$v);
      },
      expression: "filtros.data_inicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data final"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.filtros.data_fim,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "data_fim", $$v);
      },
      expression: "filtros.data_fim"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Funil"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.funilOptions
    },
    model: {
      value: _vm.filtros.id_crm_funil,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "id_crm_funil", $$v);
      },
      expression: "filtros.id_crm_funil"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Responsável"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.usuarioOptions
    },
    model: {
      value: _vm.filtros.id_usuario,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "id_usuario", $$v);
      },
      expression: "filtros.id_usuario"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.statusOptions
    },
    model: {
      value: _vm.filtros.status,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "status", $$v);
      },
      expression: "filtros.status"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Temperatura"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.temperaturaOptions
    },
    model: {
      value: _vm.filtros.temperatura,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "temperatura", $$v);
      },
      expression: "filtros.temperatura"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "d-flex align-items-end",
    attrs: {
      "md": "4",
      "lg": "2"
    }
  }, [_c('button', {
    staticClass: "btn btn-light-primary btn-block mb-7",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.loadDashboard
    }
  }, [_vm._v(" Atualizar ")])])], 1)], 1)]), _c('b-row', _vm._l(_vm.cards, function (card) {
    return _c('b-col', {
      key: card.label,
      attrs: {
        "md": "6",
        "lg": "4",
        "xl": "2"
      }
    }, [_c('router-link', {
      staticClass: "crm-metric-card",
      attrs: {
        "to": card.to
      }
    }, [_c('span', [_vm._v(_vm._s(card.label))]), _c('strong', [_vm._v(_vm._s(card.value))]), _c('small', [_vm._v(_vm._s(card.hint))])])], 1);
  }), 1), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h3', {
    staticClass: "card-label"
  }, [_vm._v("Próximas tarefas")])]), _c('div', {
    staticClass: "card-toolbar"
  }, [_c('router-link', {
    staticClass: "btn btn-light-primary btn-sm",
    attrs: {
      "to": {
        name: 'crmTarefas'
      }
    }
  }, [_vm._v(" Abrir tarefas ")])], 1)]), _c('div', {
    staticClass: "card-body"
  }, [_vm.tarefasCriticas.length ? _c('div', {
    staticClass: "crm-critical-list"
  }, _vm._l(_vm.tarefasCriticas, function (item) {
    return _c('button', {
      key: item.id_crm_atividade,
      staticClass: "crm-critical-item",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirTarefa(item);
        }
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(item.titulo))]), _c('small', [_vm._v(" " + _vm._s(item.oportunidade || item.contato || "Sem cliente") + " · " + _vm._s(_vm.formatDateTime(item.vencimento_em)) + " ")]), _c('span', [_vm._v(" " + _vm._s(item.tipo || "Tarefa") + " · " + _vm._s(item.usuario || "Sem responsável") + " ")])]), _c('div', {
      staticClass: "crm-status-pill",
      class: {
        'crm-status-pill-danger': item.atrasada
      }
    }, [_vm._v(" " + _vm._s(item.atrasada ? "Atrasada" : "Próxima") + " ")])]);
  }), 0) : _c('div', {
    staticClass: "crm-empty-state"
  }, [_vm._v(" Nenhuma tarefa próxima exigindo atenção. ")])])])]), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h3', {
    staticClass: "card-label"
  }, [_vm._v("Agenda próxima")])]), _c('div', {
    staticClass: "card-toolbar"
  }, [_c('router-link', {
    staticClass: "btn btn-light-primary btn-sm",
    attrs: {
      "to": {
        name: 'crmAgenda'
      }
    }
  }, [_vm._v(" Abrir agenda ")])], 1)]), _c('div', {
    staticClass: "card-body"
  }, [_vm.agendaCritica.length ? _c('div', {
    staticClass: "crm-agenda-list"
  }, _vm._l(_vm.agendaCritica, function (item) {
    return _c('button', {
      key: item.id_crm_agenda,
      staticClass: "crm-agenda-item",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirAgenda(item);
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatDateTime(item.data_inicio)))]), _c('span', [_vm._v(_vm._s(item.titulo))]), _c('small', [_vm._v(" " + _vm._s(item.oportunidade || item.contato || "Sem cliente") + " · " + _vm._s(_vm.statusAgendaLabel(item.status)) + " ")])]);
  }), 0) : _c('div', {
    staticClass: "crm-empty-state"
  }, [_vm._v(" Nenhum compromisso próximo exigindo atenção. ")])])])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "7"
    }
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h3', {
    staticClass: "card-label"
  }, [_vm._v("Oportunidades em atenção")])]), _c('div', {
    staticClass: "card-toolbar text-muted"
  }, [_vm._v("Score de prioridade")])]), _c('div', {
    staticClass: "card-body"
  }, [_vm.oportunidadesCriticas.length ? _c('div', {
    staticClass: "crm-critical-list"
  }, _vm._l(_vm.oportunidadesCriticas, function (item) {
    return _c('button', {
      key: item.id_crm_oportunidade,
      staticClass: "crm-critical-item",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirOportunidade(item);
        }
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(item.titulo))]), _c('small', [_vm._v(" " + _vm._s(item.contato || item.pessoa || "Sem contato") + " · " + _vm._s(item.etapa || "Sem etapa") + " ")]), _c('span', [_vm._v(_vm._s(_vm.prioridadeMotivos(item)))])]), _c('div', {
      staticClass: "crm-score"
    }, [_vm._v(" " + _vm._s(item.score_prioridade || 0) + " ")])]);
  }), 0) : _c('div', {
    staticClass: "crm-empty-state"
  }, [_vm._v(" Nenhuma oportunidade crítica nos filtros atuais. ")])])])]), _c('b-col', {
    attrs: {
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h3', {
    staticClass: "card-label"
  }, [_vm._v("Atalhos CRM")])])]), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "crm-action-list"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'crmFunil'
      }
    }
  }, [_c('strong', [_vm._v("Funil")]), _c('span', [_vm._v(_vm._s(_vm.funilAtalhoLabel))])]), _c('router-link', {
    attrs: {
      "to": {
        name: 'crmAgenda'
      }
    }
  }, [_c('strong', [_vm._v("Agenda")]), _c('span', [_vm._v(_vm._s(_vm.agendaProximaLabel))])]), _c('router-link', {
    attrs: {
      "to": {
        name: 'crmRelatorios'
      }
    }
  }, [_c('strong', [_vm._v("Relatórios")]), _c('span', [_vm._v("Gráficos e análises completos por período.")])])], 1)])])])], 1), _c('b-modal', {
    attrs: {
      "id": "crm-ganhas-modal",
      "title": "Oportunidades ganhas",
      "size": "lg",
      "hide-footer": ""
    }
  }, [_vm.oportunidadesGanhas.length ? _c('div', {
    staticClass: "crm-won-list"
  }, _vm._l(_vm.oportunidadesGanhas, function (item) {
    return _c('button', {
      key: item.id_crm_oportunidade,
      staticClass: "crm-won-item",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirOportunidadeGanha(item);
        }
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(item.titulo))]), _c('small', [_vm._v(" " + _vm._s(item.contato || item.pessoa || "Sem contato") + " · " + _vm._s(_vm.formatDateTime(item.ganho_em)) + " ")]), _c('span', [_vm._v(" " + _vm._s(item.funil || "Funil") + " · " + _vm._s(item.etapa || "Fechamento") + " ")])]), _c('div', {
      staticClass: "crm-won-meta"
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatMoney(item.valor_principal || 0)))]), _c('small', [_vm._v(" " + _vm._s(item.contrato_label || _vm.statusContratoLabel(item)) + " ")])])]);
  }), 0) : _c('div', {
    staticClass: "crm-empty-state"
  }, [_vm._v(" Nenhuma oportunidade ganha encontrada nos filtros atuais. ")])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };